import ArtifactService from "../api/artifact"
import ArchiveService from "../api/archive"


export const state = () => ({
    hero: null,
    item: null,
    item_loading: false,
    item_loaded: false,
    related_items: [],
    type: 'artifact'
})

export const actions = {
    async hero({commit}, params) {
        commit('setHero', params)
        commit('setItemLoading', false)
        commit('setItemLoaded', true)
    },
    async type({commit}, params) {
        commit('setType', params)
    },
    async loading({commit}, status) {
        commit('setItemLoading', status)
    },
    async loaded({commit}, status) {
        commit('setItemLoaded', status)
    },
    async fetch({commit, dispatch, state}, params) {
        if(state.item_loading) {
            return
        }

        commit('setItemLoading', true)
        if (state.type == 'artifact') {
            await ArtifactService.detail(params.locale, params.id)
                .then((response) => {
                    commit('setItem', response.data)
                    if (response.data.media) {
                         let images = response.data.media.filter(m => m.mime_type == 'image');
                         if (images.length > 0) {
                            dispatch('hero', images[0]);
                         }
                    } else {
                        commit('setItemLoading', false)
                        commit('setItemLoaded', true)
                    }
                })
                .catch((error) => {
                    console.log(`Artifact API Error => ${error}`)
                })
        } else {
            await ArchiveService.detail(params.locale, params.id)
                .then((response) => {
                    commit('setItem', response.data)
                    if (response.data.media) {
                         let images = response.data.media.filter(m => m.mime_type == 'image');
                         if (images.length > 0) {
                            dispatch('hero', images[0]);
                         }
                    } else {
                        commit('setItemLoading', false)
                        commit('setItemLoaded', true)
                    }
                })
                .catch((error) => {
                    console.log(`Archive API Error => ${error}`)
                })
        }
    },
    async related_items({commit, state}, params) {
        if (state.type == 'artifact') {
            await ArtifactService.search(params.locale, params.q, params.sort, params.order, params.page, params.size, params.type)
                .then((response) => {
                    commit('setRelatedItems', response.data.results)
                })
                .catch((error) => {
                    console.log(`Archive API Error => ${error}`)
                })
        } else {
            await ArchiveService.search(params.locale, params.q, params.sort, params.order, params.page, params.size, params.type)
            .then((response) => {
                    commit('setRelatedItems', response.data.results)
                })
                .catch((error) => {
                    console.log(`Archive API Error => ${error}`)
                })
    
        }
    }
}

export const mutations = {
    setHero(state, media) {
        state.hero = media;
    },
    setType(state, type) {
        state.type = type;
    },
    setItem(state, item) {
        state.item = item
        state.item_loading = false
    },
    setItemLoading(state, loading) {
        state.item_loading = loading
    },
    setItemLoaded(state, loaded) {
        state.item_loaded = loaded
    },
    setRelatedItems(state, items) {
        state.related_items = items
    },
}

export const getters = {
    hero(state) {
        return state.hero
    },
    type(state) {
        return state.type
    },
    json_ld(state) {
        let json = {};
        let item = state.item;

        if (state.type == 'archive') {
            json = {
                "@type": "ArchiveComponent",
                "name": item.title,
                "url": window.location.href,
                "holdingArchive": {
                    "@type": "ArchiveOrganization",
                    "name": item.museum    
                }
            }
            if (item.subjects) json["keywords"] = item.subjects.join(', ')
            if (item.publisher_date) json["temporal"] = item.publisher_date.join(', ')
            if (item.scope_and_content) json["description"] = item.scope_and_content
        } else {
            json = {
                "@type": "Thing",
                "name": item.title,
                "url": window.location.href
            }
            if (item.SummaryData) json["description"] = item.SummaryData
            if (item.material) json["material"] = item.material.join(', ')
            if (item.category) json["keywords"] = item.category.join(', ')
        }

        return json;
    },
    item(state) {
        return state.item
    },
    item_loading(state) {
        return state.item_loading
    },
    item_loaded(state) {
        return state.item_loaded
    },
    related_items(state) {
        return state.related_items
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
